(function () {

  function resetItems(items) {
    items.forEach(function (el) {
      el.classList.remove('trst-enter', 'trst-exit');
      el.style.opacity = '0';
    });
  }

  function initTrst(wrap, force) {
    if (wrap.dataset.trstInit && !force) return;
    wrap.dataset.trstInit = '1';

    if (wrap._trstInterval) {
      clearInterval(wrap._trstInterval);
      wrap._trstInterval = null;
    }

    var items = Array.prototype.slice.call(wrap.querySelectorAll('.trst-item'));
    if (!items.length) return;

    resetItems(items);

    if (items.length === 1) {
      items[0].style.opacity = '1';
      items[0].style.position = 'relative';
      return;
    }

    var speed = (parseInt(wrap.dataset.speed) || 3) * 1000;
    var cur = 0;

    items[0].classList.add('trst-enter');
    setTimeout(function () {
      items[0].classList.remove('trst-enter');
      items[0].style.opacity = '1';
    }, 500);

    wrap._trstInterval = setInterval(function () {
      var prev = cur;
      cur = (cur + 1) % items.length;

      items[prev].classList.add('trst-exit');
      setTimeout(function () {
        items[prev].classList.remove('trst-exit');
        items[prev].style.opacity = '0';
      }, 380);

      setTimeout(function () {
        items[cur].classList.add('trst-enter');
        setTimeout(function () {
          items[cur].classList.remove('trst-enter');
          items[cur].style.opacity = '1';
        }, 500);
      }, 180);

    }, speed);
  }

  function initAll(force) {
    document.querySelectorAll('.trst').forEach(function (el) {
      initTrst(el, force);
    });
  }

  initAll(false);

  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      document.querySelectorAll('.trst').forEach(function (el) {
        delete el.dataset.trstInit;
      });
      initAll(true);
    }
  });

  if (!window._trstObserverActive) {
    window._trstObserverActive = true;
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.classList && node.classList.contains('trst')) {
            initTrst(node, false);
          }
          node.querySelectorAll && node.querySelectorAll('.trst').forEach(function (el) {
            initTrst(el, false);
          });
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

})();